import React, { Suspense } from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useEpiPageContent } from '../hooks/useEpiPageContent';
import { EcdContentPage, EcdNotFoundPage, PageType } from '../models/ecd-page-models';

// eslint-disable-next-line @typescript-eslint/naming-convention
const EcdContentPageView = React.lazy(() => import('../page-type/ecd-content-page'));

// eslint-disable-next-line @typescript-eslint/naming-convention
const EcdNotFoundPageView = React.lazy(() => import('../page-type/ecd-not-found-page'));

function PageFactory(){

    const pageData = useEpiPageContent();

    if (!pageData) {
        return <>
        <LoadingCircle />                
        </>;
    }

    function RenderFactoryContent(){        
        switch (pageData?.pageType) {  
            case PageType.EcdContentPage:
                return <Suspense fallback={<LoadingCircle />}><EcdContentPageView pageData={pageData as EcdContentPage} /></Suspense>;            

            case PageType.NotFoundPage:                
                return <Suspense fallback={<LoadingCircle />}><EcdNotFoundPageView pageData={pageData as EcdNotFoundPage} /></Suspense>;            
            
            default: {
                return <>Page Factory</>;
            }
        }
    }

    return (
        <Suspense fallback={<LoadingCircle />}>
            <RenderFactoryContent/>            
        </Suspense>
    );
}

export default PageFactory;
